<template lang="pug">
	.data-table
		.header-controls(v-if="header")
			.count-per-page
				label
					span Show
					select.custom-select.custom-select-sm.form-control.form-control-sm(v-model="countPerPage" @change="updateCountPerPage")
						option(value="10") 10
						option(value="25") 25
						option(value="50") 50
						option(value="100") 100
						option(value="auto") auto
					span entries
			.field-filters
				.field-filter(v-for="filter in filters" v-if="filter.display")
					label
						span {{filter.title}}:
						select.custom-select.custom-select-sm.form-control.form-control-sm(:value="filter.value" @change="updateFieldFilterValue(filter, $event.target.value)")
							option(v-for="option in filter.options" :value="option.value") {{option.title}}
			//- Дополнительные элементы управления в шапке таблицы (например переключатели), передаются из экрана-родителя через именованный слот и отображаются слева от Search
			slot(name="header-controls-extra")
			.filter
				label
					span Search:
					input.form-control.form-control-sm(type="search" placeholder="" v-model="filter" @input="updateFilter" ref="search")
			.buttons
				.button(v-for="button in buttons" v-if="button.position === 'top'")
					button.btn.btn-sm.btn-primary(@click="button.action()")
						.icon.fa.fa-plus
						| &nbsp;&nbsp;{{button.title}}
		.table
			table
				thead
					tr(role="row")
						th(v-for="field in fields" v-if="field.display" :class="{'sorting': field.sortingAllowed, 'sorting-asc': sortingField === field.fieldName && sortingDirection === 'asc', 'sorting-desc': sortingField === field.fieldName && sortingDirection === 'desc'}" :style="{width: field.width || 'auto'}" @click="changeSorting(field)")
							span {{field.title || field.fieldName}}
				tbody
					tr(v-for="(row, index) in rows" :class="{odd: index % 2 === 0, clickable: !!rowClick && row && !row.justToDraw}" @click="(rowClick && row && !row.justToDraw) ? rowClick(row) : null")
						td(v-for="field in fields" v-if="field.display" :class="{clickable: !!field.click && row && !row.justToDraw, [field.type]: true}" @click="(field.click && row && !row.justToDraw) ? field.click(row, field) : null" :set="value = getFieldValue(row, field)")
							.td-data(v-if="row && row.justToDraw")
							.td-data(v-else-if="row" :class="field.class || []")
								span(v-if="field.type === 'number'" :style="getFieldStyles(row, field, value)") {{value}}
								span(v-else-if="field.type === 'string'" :style="getFieldStyles(row, field, value)") {{value}}
								span.link(v-else-if="field.type === 'link'" :style="getFieldStyles(row, field, value)")
									a(:href="value" target="_blank") {{value}}
								span.date(v-else-if="field.type === 'date'" :style="getFieldStyles(row, field, value)" :title="value.toLocaleString()")
									span.day {{getLocaleDateString(value)}}
									span.time {{value.toLocaleTimeString()}}
								span(v-else-if="field.type === 'image'" :style="getFieldStyles(row, field, value)")
									img(:src="value")
								span(v-else-if="field.type === 'button:hover'" :style="getFieldStyles(row, field, value)")
									button.btn.btn-sm.btn-secondary(type="button" v-b-tooltip.hover="{delay: { show: 100, hide: 100 }, title: JSON.stringify(value)}")
										.icon.fa.fa-info
								span(v-else-if="field.type === 'button:confirm'" :style="getFieldStyles(row, field, value)")
									button.btn.btn-sm.btn-secondary(type="button" v-on:click="showConfirm(field.title, value)" style="width: 30px")
										.icon.fa.fa-info
								span.list(v-else-if="field.type === 'array'")
									span(v-for="v in value" :style="getFieldStyles(row, field, v)") {{v}}
								span(v-else-if="field.type === 'boolean'" :style="getFieldStyles(row, field, value)")
									span(v-if="field.editAllowed")
										label.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
											input.switch-input.form-check-input(type="checkbox" v-model="row[field.fieldName]" @change="field.onChange ? field.onChange(row) : toggleFieldValue(row, field)")
											span.switch-slider(data-checked="On" data-unchecked="Off")
											span.switch-handle
									span(v-else)
										.icon.fa.fa-check.boolean-true(v-if="value")
										.icon.fa.fa-minus.boolean-false(v-else)
								span(v-else-if="field.type === 'buttons'" :styles="getFieldStyles(row, field, value)")
									button.btn.btn-sm(v-for="button in field.buttons" type="button" :class="button.class" @click="button.click ? button.click(row) : null")
										.icon.fa(:class="button.icon")
										span {{button.title}}
							.td-data(v-else="!row")
								.icon.fa.fa-spinner.fa-spin(v-if="field.fieldName === keyField")
								span(v-else) ...
		.footer-controls(v-if="footer")
			.data-count(v-show="count > 0") Showing {{this.page * this.actualCountPerPage + 1}} to {{Math.min(this.page * this.actualCountPerPage + this.actualCountPerPage, this.count)}} of {{this.count}} entries
			.data-count(v-show="count === 0") There are no records matching your criteria
			.pages
				ul.pagination
					li.paginate_button.page-item.previous(:class="{disabled: page === 0}")
						a.page-link(href="#" @click="previousPage") Previous
					li.paginate_button.page-item.page(v-for="pageToDisplay in pagesToDisplay" :class="{active: pageToDisplay === page}")
						a.page-link(href="#" @click="setPage(pageToDisplay)") {{ pageToDisplay + 1 }}
					li.paginate_button.page-item.next(:class="{disabled: page === pagesCount - 1}")
						a.page-link(href="#" @click="nextPage") Next
</template>

<script>

	import Screen 				from './../../mixins/screen'

	export default {
		name: "DataTable",
		mixins: [Screen],
		screen: {
			updateOn: [],
			events: {
				"Server Data Received": function(data, rawData, serverId) {

					if (data.DatabaseData?.name !== this.name) return;

					// Данные одной таблицы с разных нод кластера не должны смешиваться
					if (this.serverId && serverId !== this.serverId) return;

					this.updateData(data.DatabaseData);

				}
			}
		},
		props: {
			name: {
				type: String,
				default() {
					return this.$options.propsData.entity;
				}
			},
			entity: String,
			fields: Array,
			filters: Array,
			buttons: Array,
			keyField: {
				type: String,
				default: "id"
			},
			entriesCount: {
				type: String,
				default: "auto"
			},
			sort: {
				type: Array,
				default: ["id", "asc"]
			},
			overloadCount: {
				type: Number,
				default: 0
			},
			// Нода кластера, у которой запрашиваются данные: по умолчанию - нода выбранного
			// паблишера (Client/Libs/Service.Socket.js, getDefaultServerId)
			serverId: Number,
			updateOn: Array,
			updateIf: Function,
			focusOn: String,
			rowClick: Function,
			header: {
				type: Boolean,
				default: true
			},
			footer: {
				type: Boolean,
				default: true
			},
			heightOffset: Number
		},
		data() {

			//Сохраним сюда данные без сортировки чтобы при изменении фильтра или других параметров быстро взять отсюда данные и отобразить не дожидаясь ответа от сервера
			this.rowsByKey = {};

			//Сюда будет записывать уже сортированные массивы сразу заполняя их полный размер чтобы вставлять данные на нужную страницу
			this.rowsByFilters = {};

			this.rows = [];

			this.mounted = false;

			return {
				showed: true,
				filter: '',
				count: 0,
				countPerPage: this.entriesCount || 'auto',
				actualCountPerPage: 0,
				page: 0,
				pagesCount: 0,
				pagesToDisplay: [],
				maxPagesToDisplay: 10,
				rowHeight: 47,
				sortingField: this.sort[0],
				sortingDirection: this.sort[1]
			};

		},
		watch: {
			// Сменилась нода: строки прежней ноды больше не показываем и запрашиваем данные заново
			serverId: function() {

				this.rowsByKey = {};
				this.rowsByFilters = {};
				this.rows = [];
				this.count = 0;
				this.page = 0;

				this.collectData();

			}
		},
		mounted() {

			this.addUpdateEvent(this.updateOn);

			if (this.focusOn) Broadcast.on(this.focusOn, () => {

				this.$nextTick(() => {

					this.$nextTick(() => {

						this.$refs["search"].focus();

					});

				});

			}, "vue-component-focus-on-" + this._uid + "-" + this.$options.name);

			let onResize = () => {

				if (this.countPerPage === "auto") this.updateCountPerPage();

			};

			window.addEventListener("resize", onResize);

			this.$once('hook:beforeDestroy', () => {

				if (this.focusOn) Broadcast.off(this.focusOn, "vue-component-focus-on-" + this._uid + "-" + this.$options.name);

				window.removeEventListener("resize", onResize);

			});

			this.sortingField = window.localStorage.getItem(`data-table:${this.name}:sorting-field`) || this.sortingField;
			this.sortingDirection = window.localStorage.getItem(`data-table:${this.name}:sorting-direction`) || this.sortingDirection;
			this.countPerPage = window.localStorage.getItem(`data-table:${this.name}:count-per-page`) || this.countPerPage;
			this.filter = window.localStorage.getItem(`data-table:${this.name}:filter`) || this.filter;
			this.page = parseInt(window.localStorage.getItem(`data-table:${this.name}:page`) || 0);

			_.each(this.filters, filter => {

				if (window.localStorage.getItem(`data-table:${this.name}:field-filter:${filter.field}`)) filter.value = window.localStorage.getItem(`data-table:${this.name}:field-filter:${filter.field}`);

			});

			if (this.page > this.pagesCount - 1) this.page = this.pagesCount - 1;
			if (this.page < 0) this.page = 0;

			this.updateActualCountPerPage();

			this.mounted = true;

			//this.collectData(); // Три варнинга в самом начале запуска дашборда если это не закоментить

		},
		methods: {
			collectData(eventName) {

				if (!this.mounted) return;
				if (this.updateIf && !this.updateIf()) return;

				let fields = _.uniq(_.compact(_.map(this.fields, field => field.fieldName)));
				if (!_.includes(fields, this.keyField)) fields.push(this.keyField);

				if (this.page > this.pagesCount - 1) this.page = this.pagesCount - 1;
				if (this.page < 0) this.page = 0;

				this.updateActualCountPerPage();

				if (eventName !== 'updateData') {

					// serverId пустой - запрос уходит на ноду по умолчанию (нода выбранного паблишера)
					Server.sendToServer({
						UpdateDatabaseData: {
							name: this.name,
							entity: this.entity,
							fields,
							filter: this.filter,
							filters: _.map(_.filter(this.filters, filter => filter.value), filter => _.pick(filter, ['field', 'type', 'value'])),
							sortingField: this.sortingField,
							sortingDirection: this.sortingDirection,
							from: (this.overloadCount && ((this.page + 1) * this.actualCountPerPage < this.overloadCount)) ? 0 : this.page * this.actualCountPerPage,
							count: this.overloadCount || this.actualCountPerPage
						}
					}, this.serverId);

				}

			},
			updateData(data) {

				let filtersKey = this.getFiltersKey(data);

				if (!this.rowsByFilters[filtersKey]) this.rowsByFilters[filtersKey] = Array(data.count);
				else this.rowsByFilters[filtersKey].length = data.count;

				_.each(data.rows, (row, index) => {

					_.each(this.fields, field => {

						if (field.type === 'date') row[field.fieldName] = new Date(row[field.fieldName]);
						if (field.split && row[field.fieldName]?.split) row[field.fieldName] = row[field.fieldName].split(field.split);

					});

					if (this.rowsByKey[row[this.keyField]]) {

						_.extend(this.rowsByKey[row[this.keyField]], row);

					} else {

						this.rowsByKey[row[this.keyField]] = row;

					}

					//Помещаем ссылку на объект из rowsByKey хэша, чтобы не потреблять лишнюю память на одни и теже объекты в разных вариантах сортировки
					this.rowsByFilters[filtersKey][data.from + index] = this.rowsByKey[row[this.keyField]];

				});

				this.updateRows(false);

				//Передадим имя-причину обновления чтобы в методе collectData предотвратить зацикливание запросов к серверу
				this.update('updateData');

			},
			updateRows(isRequestData = true) {

				let filtersKey = this.getFiltersKey(this);

				let rows = [];

				//Если уже есть какие-то серверные данные по текущему фильтру - используем их
				if (this.rowsByFilters[filtersKey]) {

					rows = this.rowsByFilters[filtersKey];

				//Если нету - возьмём временно данные из общего хранилища rowsByKey
				} else {

					//По факту лучше выглядит если ничего не отображать чем прыгающие данные

					/*//Фильтруем по введённому значению в search строке
					rows = _.filter(_.values(this.rowsByKey), row => {

						let result = false;

						_.each(this.fields, field => {

							if (field.filteringAllowed && (row[field.fieldName] + '').indexOf(this.filter) > -1) result = true;

						});

						return result;

					});

					//Сортируем
					rows = _.orderBy(rows, this.sortingField, this.sortingDirection);*/

				}

				this.count = rows.length;

				//this.countPerPage строковое, а нам нужно целое число - количество строк на экране
				this.updateActualCountPerPage();

				this.pagesCount = Math.ceil(this.count / this.actualCountPerPage);

				if (this.page > this.pagesCount - 1) this.page = this.pagesCount - 1;
				if (this.page < 0) this.page = 0;

				if (this.pagesCount > this.maxPagesToDisplay) {

					this.pagesToDisplay = [];

					//Сначала помещаем maxPagesToDisplay / 2 страниц, которые шли перед текущей страницей
					for (let i = this.page - Math.ceil(this.maxPagesToDisplay / 2); i < this.page; i++)
						if (i >= 0) this.pagesToDisplay.push(i);

					//Затем помещаем текущую страницу
					this.pagesToDisplay.push(this.page);

					//Затем добавляем старницы, которые идут после текущей, до тех пор пока не наберём нужное количество
					for (let i = this.page + 1; i < this.pagesCount; i++)
						if (this.pagesToDisplay.length <= this.maxPagesToDisplay + 1) this.pagesToDisplay.push(i);

					//Если всё же не хватает выбранных страниц до maxPagesToDisplay - добавляем ещё дальше предыдущие
					for (let i = this.pagesToDisplay[0] - 1; i >= 0; i--)
						if (this.pagesToDisplay.length <= this.maxPagesToDisplay + 1) this.pagesToDisplay.splice(0, 0, i);

				} else {

					this.pagesToDisplay = _.map(_.fill(Array(this.pagesCount), 1), (value, index) => index);

				}

				this.rows = rows.slice(this.page * this.actualCountPerPage, this.page * this.actualCountPerPage + this.actualCountPerPage);

				if (this.rows.length < this.actualCountPerPage && this.pagesCount > 1) {

					for (let i=this.rows.length; i<this.actualCountPerPage; i++) this.rows.push({justToDraw: true});

				}

				if (isRequestData) {

					clearTimeout(this.requestDataTimeout);
					this.requestDataTimeout = setTimeout(() => {

						this.collectData();

					}, 500);

				}

			},
			getFieldValue(row, field) {

				if (!row) return null;

				let value = row[field.fieldName];

				if (field.type === 'array') {

					value = _.compact(_.map(value, v => field.displayTransform(v, row, field)));

				} else {

					if (field.displayTransform) value = field.displayTransform(value, row, field);

				}

				return value;

			},
			getFieldStyles(row, field, transformedValue) {

				if (!row) return null;

				let styles = {};

				if (field.displayStyles) styles = field.displayStyles(transformedValue, row, field);

				return styles;

			},
			changeSorting(field) {

				if (!field.sortingAllowed) return;

				if (this.sortingField === field.fieldName) this.sortingDirection = (this.sortingDirection === 'asc') ? 'desc' : 'asc';
				else {
					this.sortingField = field.fieldName;
					this.sortingDirection = 'asc';
				}

				window.localStorage.setItem(`data-table:${this.name}:sorting-field`, this.sortingField);
				window.localStorage.setItem(`data-table:${this.name}:sorting-direction`, this.sortingDirection);

				this.updateRows();

			},
			toggleFieldValue(row, field) {



			},
			getLocaleDateString(date) {

				date = date.toLocaleDateString();

				if (date === (new Date()).toLocaleDateString()) date = 'Today';
				else if (date === (new Date(Date.now() - 24 * 3600 * 1000)).toLocaleDateString()) date = 'Yesterday';

				return date;

			},
			updateCountPerPage() {

				window.localStorage.setItem(`data-table:${this.name}:count-per-page`, this.countPerPage);

				this.updateRows();

			},
			updateActualCountPerPage() {

				if (this.countPerPage === 'auto') this.actualCountPerPage = Math.floor((window.innerHeight - this.heightOffset - 170) / this.rowHeight);
				else this.actualCountPerPage = parseInt(this.countPerPage);

				if (this.actualCountPerPage < 2) this.actualCountPerPage = 2;
				if (this.actualCountPerPage > 1000) this.actualCountPerPage = 1000;

			},
			updateFilter() {

				window.localStorage.setItem(`data-table:${this.name}:filter`, this.filter);

				this.updateRows();

			},
			updateFieldFilterValue(filter, value) {

				window.localStorage.setItem(`data-table:${this.name}:field-filter:${filter.field}`, value);

				filter.value = value;

				this.updateRows();

			},
			previousPage() {

				if (this.page > 0) this.page--;

				window.localStorage.setItem(`data-table:${this.name}:page`, this.page);

				this.collectData();
				this.updateRows(false);

			},
			setPage(page) {

				this.page = page;

				window.localStorage.setItem(`data-table:${this.name}:page`, this.page);

				this.collectData();
				this.updateRows(false);

			},
			nextPage() {

				if (this.page < this.pagesCount - 1) this.page++;

				window.localStorage.setItem(`data-table:${this.name}:page`, this.page);

				this.collectData();
				this.updateRows(false);

			},
			getFiltersKey(source) {

				let key = `${source.sortingField}-${source.sortingDirection}-${source.filter}`;

				_.each(source.filters, filter => {

					if (filter.value) key += `-${filter.field}:${filter.value}`;

				});

				return key;

			},
			showConfirm(caption, message) {

				Broadcast.call('Show Confirm', [{
					caption,
					message,
					confirmButtonText: 'OK',
					confirmButtonIcon: 'fa-ok',
					height: 'auto',
					confirmCallback: () => {

					}
				}]);

			}
		}
	}
</script>

<style lang="sass">

	.data-table
		width: 100%

		.header-controls
			display: flex
			flex-direction: row
			justify-content: space-between
			width: 100%

			.count-per-page
				display: flex
				padding-right: 15px
				padding-left: 15px

			.field-filters
				display: flex
				flex-direction: row
				flex-wrap: nowrap
				margin-left: auto
				white-space: nowrap

				.field-filter
					margin-left: 15px

			.filter
				display: flex
				padding-right: 15px
				padding-left: 15px

			.buttons
				display: flex
				flex-direction: row
				flex-wrap: nowrap
				margin-right: 15px

			label
				display: flex
				flex-direction: row
				flex-wrap: nowrap
				justify-content: center
				align-items: center

				select
					margin-left: 0.5rem
					margin-right: 0.5rem

				input
					margin-left: 0.5rem
					width: 200px
		.table
			width: 100%
			padding-right: 15px
			padding-left: 15px
			padding-top: 10px

			table
				width: 100%
				border: 1px solid rgba(255, 255, 255, 0.1)
				border-collapse: collapse
				color: rgba(255, 255, 255, 0.87)
				background-color: transparent

				thead

					th
						border: 1px solid rgba(255, 255, 255, 0.1)
						color: rgba(255, 255, 255, 0.87)
						cursor: pointer
						position: relative
						user-select: none

						&::before
							display: none
							position: absolute
							bottom: 0.9em
							right: 1em
							content: "\2191"
							opacity: 0.3

						&::after
							display: none
							position: absolute
							bottom: 0.9em
							right: 0.5em
							content: "\2193"
							opacity: 0.3

					th.sorting

						&::before
							display: block

						&::after
							display: block

					th.sorting-asc

						&::before
							opacity: 1

					th.sorting-desc

						&::after
							opacity: 1

				tbody

					tr

						td
							border-color: rgba(255, 255, 255, 0.1)
							cursor: default
							white-space: nowrap

							.td-data
								height: 22px
								overflow: visible

						td.clickable
							cursor: pointer

						td.clickable:hover
							text-decoration: underline

						td.boolean
							text-align: left

							.boolean-true
								color: var(--green)

							.boolean-false
								color: var(--red)

						td.buttons
							text-align: center

							button
								margin-top: -3px

						td.image
							padding: 6px

							img
								width: 36px
								height: 36px
								border-radius: 36px

						td.array
							padding: 6px
							font-size: 11px

							span.list
								display: flex
								flex-direction: row
								flex-wrap: wrap
								align-items: center
								height: 34px

								span
									margin-right: 5px

						td.date
							padding: 4px

							span.date
								display: flex
								flex-direction: column

								span.day

								span.time
									font-size: 12px

						td.date

							.td-data.date-only
								margin: 8px

								span.date
									flex-direction: row

									span.time
										display: none

						td.hover
							text-align: center

							button
								width: 30px
								margin-top: -3px

					tr.odd
						background-color: rgba(255, 255, 255, 0.02)

					tr.clickable
						cursor: pointer

						td
							cursor: pointer

					tr.clickable:hover
						background-color: rgba(255, 255, 255, 0.05)

		.footer-controls
			display: flex
			flex-direction: row
			justify-content: space-between
			width: 100%

			.data-count
				display: flex
				padding-right: 15px
				padding-left: 15px
				justify-content: center
				align-items: center

			.pages
				display: flex
				padding-right: 15px
				padding-left: 15px

				.pagination
					user-select: none
					margin: 0

					.page-item

						.page-link
							padding: 0.5rem 0.5rem
							background-color: rgba(255, 255, 255, 0.05)
							border-color: rgba(255, 255, 255, 0.09)
							color: rgba(255, 255, 255, 0.8)

					.page-item.page
						width: 42px
						text-align: center

					.page-item:hover

						.page-link
							background-color: rgba(255, 255, 255, 0.15)

					.page-item.disabled

						.page-link
							background-color: rgba(255, 255, 255, 0.05)
							color: #73818f

					.page-item.active

						.page-link
							background-color: rgba(255, 255, 255, 0.25)
							color: #fff

</style>

